module.exports = __webpack_public_path__ + "img/logo.d8e32c33.svg";